import installationInstructions from './installationInstructions';

const axelContent = {
  installationInstructions
}

export { axelContent };